import { Home, Radio, BookOpen, ShieldCheck, GraduationCap, Trophy, Gift, User } from "lucide-react";

export const NAV_ITEMS = [
  { to: "/home", label: "Home", icon: Home },
  { to: "/signals", label: "AI Signals", icon: Radio },
  { to: "/journal", label: "Journal", icon: BookOpen },
  { to: "/risk-management", label: "Risk", icon: ShieldCheck },
  { to: "/daily-lesson", label: "Lesson", icon: GraduationCap },
  { to: "/leaderboard", label: "Top 10", icon: Trophy },
  { to: "/giveaway", label: "Giveaway", icon: Gift },
  { to: "/profile", label: "Profile", icon: User },
];

export const MOBILE_PRIMARY = ["/home", "/signals", "/journal", "/leaderboard", "/profile"];
